/* ============================================================
   KIDDERY — Product Page JS v1.0
   Features:
   - Image gallery with thumbnail switching
   - Variant selection + URL updates + price/availability sync
   - Sticky Add to Cart bar (IntersectionObserver)
   - Quantity selector
   - Video modal (YouTube + Vimeo)
   - AJAX cart with feedback
   - FAQ open/close tracking (optional analytics hook)
   ============================================================ */

(function () {
  'use strict';

  // ── Utilities ────────────────────────────────────────────
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function formatMoney(cents) {
    return window.Shopify
      ? Shopify.formatMoney(cents, window.theme?.moneyFormat || '₹{{amount}}')
      : '₹' + (cents / 100).toFixed(0);
  }
  function getEmbedUrl(url) {
    if (!url) return null;
    // YouTube
    const ytMatch = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([A-Za-z0-9_-]{11})/);
    if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1] + '?autoplay=1&rel=0';
    // Vimeo
    const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
    if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';
    return url; // return as-is for direct MP4 etc.
  }

  // ── Product Data from Shopify ─────────────────────────────
  // Shopify injects window.kp_product via a script tag in the section.
  // We read variants from that object. Falls back gracefully if missing.
  var productData = window.kp_product || null;
  var variantData = {};
  if (productData && productData.variants) {
    productData.variants.forEach(function (v) { variantData[v.id] = v; });
  }

  // ── Gallery ───────────────────────────────────────────────
  var heroImg = $('#kp-hero-img');
  var thumbBtns = $$('.kp-gallery__thumb:not(.kp-gallery__thumb--video)');

  thumbBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.dataset.src;
      var alt = btn.dataset.alt;
      if (heroImg && src) {
        heroImg.style.opacity = '0.6';
        heroImg.src = src;
        heroImg.alt = alt || '';
        heroImg.onload = function () { heroImg.style.opacity = '1'; };
      }
      thumbBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  });

  // ── Video Modal ───────────────────────────────────────────
  var videoModal = $('#kp-video-modal');
  var videoIframe = $('#kp-video-iframe');
  var videoCloseBackdrop = $('#kp-video-close');
  var videoCloseBtn = $('#kp-video-close-btn');

  function openVideo(url) {
    var embedUrl = getEmbedUrl(url);
    if (!embedUrl || !videoModal || !videoIframe) return;
    videoIframe.src = embedUrl;
    videoModal.classList.add('is-open');
    videoModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeVideo() {
    if (!videoModal || !videoIframe) return;
    videoIframe.src = '';
    videoModal.classList.remove('is-open');
    videoModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // Video thumb in gallery
  $$('.kp-gallery__thumb--video').forEach(function (btn) {
    btn.addEventListener('click', function () { openVideo(btn.dataset.video); });
  });

  // Video trigger in assembly section
  $$('.kp-video-trigger').forEach(function (btn) {
    btn.addEventListener('click', function () { openVideo(btn.dataset.video); });
  });

  if (videoCloseBackdrop) videoCloseBackdrop.addEventListener('click', closeVideo);
  if (videoCloseBtn) videoCloseBtn.addEventListener('click', closeVideo);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeVideo(); });

  // ── Variant Selection ─────────────────────────────────────
  var variantBtns = $$('.kp-variant-btn');
  var variantIdInput = $('#kp-variant-id');
  var priceEl = $('#kp-price-current');
  var compareEl = $('#kp-price-compare');
  var savingEl = $('#kp-price-saving');
  var atcBtn = $('#kp-atc-btn');
  var atcText = $('#kp-atc-text');
  var stickyPrice = $('#kp-sticky-price');
  var selectedOptions = {};

  // Initialise from active buttons
  $$('.kp-variant-group').forEach(function (group, idx) {
    var activeBtn = group.querySelector('.kp-variant-btn.is-active');
    if (activeBtn) selectedOptions[idx] = activeBtn.dataset.value;
  });

  variantBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var optionIndex = parseInt(btn.dataset.optionIndex, 10);
      var value = btn.dataset.value;
      selectedOptions[optionIndex] = value;

      // Update active state within this group
      var group = btn.closest('.kp-variant-group');
      group.querySelectorAll('.kp-variant-btn').forEach(function (b) {
        b.classList.toggle('is-active', b === btn);
        b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
      });

      // Update selected label
      var labelEl = group.querySelector('.kp-variant-group__selected');
      if (labelEl) labelEl.textContent = value;

      updateVariant();
    });
  });

  function updateVariant() {
    if (!productData) return;
    var optionValues = Object.values(selectedOptions);

    var matched = productData.variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === optionValues[i]; });
    });

    if (!matched) return;

    // Update hidden input
    if (variantIdInput) variantIdInput.value = matched.id;

    // Update URL without reload
    if (history.replaceState) {
      var url = new URL(window.location);
      url.searchParams.set('variant', matched.id);
      history.replaceState(null, '', url.toString());
    }

    // Update price
    if (priceEl) priceEl.textContent = formatMoney(matched.price);
    if (stickyPrice) stickyPrice.textContent = formatMoney(matched.price);

    if (matched.compare_at_price && matched.compare_at_price > matched.price) {
      var saving = matched.compare_at_price - matched.price;
      var savingPct = Math.round(saving * 100 / matched.compare_at_price);
      if (compareEl) {
        compareEl.style.display = '';
        compareEl.textContent = formatMoney(matched.compare_at_price);
      }
      if (savingEl) {
        savingEl.style.display = '';
        savingEl.textContent = 'Save ' + formatMoney(saving) + ' (' + savingPct + '% off)';
      }
    } else {
      if (compareEl) compareEl.style.display = 'none';
      if (savingEl) savingEl.style.display = 'none';
    }

    // Update ATC availability
    if (atcBtn && atcText) {
      if (matched.available) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcText.textContent = 'Add to cart · ' + formatMoney(matched.price);
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcText.textContent = 'Sold out';
      }
    }

    // Update urgency text from inventory
    var urgencyEl = $('#kp-urgency');
    if (urgencyEl && matched.inventory_management === 'shopify' && matched.inventory_quantity > 0 && matched.inventory_quantity <= 20) {
      urgencyEl.innerHTML = '<span aria-hidden="true">⚠</span> Only ' + matched.inventory_quantity + ' left in stock — order soon';
      urgencyEl.style.display = '';
    }
  }

  // ── Quantity Selector ─────────────────────────────────────
  var qtyInput = $('#kp-qty');
  var qtyHidden = $('#kp-qty-hidden');
  var qtyMinus = $('#kp-qty-minus');
  var qtyPlus = $('#kp-qty-plus');

  function updateQty(delta) {
    if (!qtyInput) return;
    var current = parseInt(qtyInput.value, 10) || 1;
    var next = Math.max(1, Math.min(99, current + delta));
    qtyInput.value = next;
    if (qtyHidden) qtyHidden.value = next;
  }

  if (qtyMinus) qtyMinus.addEventListener('click', function () { updateQty(-1); });
  if (qtyPlus) qtyPlus.addEventListener('click', function () { updateQty(1); });
  if (qtyInput) {
    qtyInput.addEventListener('change', function () {
      var v = parseInt(qtyInput.value, 10);
      if (isNaN(v) || v < 1) qtyInput.value = 1;
      if (qtyHidden) qtyHidden.value = qtyInput.value;
    });
  }

  // ── AJAX Add to Cart ──────────────────────────────────────
  var atcForm = $('#kp-atc-form');

  if (atcForm) {
    atcForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('#kp-atc-btn');
      var text = $('#kp-atc-text');
      if (!btn || btn.disabled) return;

      var formData = new FormData(atcForm);
      var payload = {
        id: formData.get('id'),
        quantity: formData.get('quantity') || 1
      };

      btn.disabled = true;
      if (text) text.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status && data.status !== 200) {
            if (text) text.textContent = data.description || 'Error — please try again';
            btn.disabled = false;
            return;
          }
          if (text) text.textContent = '✓ Added to cart!';

          // Update cart count if theme supports it
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var countEls = $$('[data-cart-count], .cart-count, .js-cart-count');
              countEls.forEach(function (el) { el.textContent = cart.item_count; });
              // Trigger theme cart drawer if it exists
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
            });

          // Open Shopify theme cart drawer
          if (window.Shopify && window.Shopify.PaymentButton) {
            window.Shopify.PaymentButton.init();
          }

          setTimeout(function () {
            btn.disabled = false;
            if (text) text.textContent = 'Add to cart · ' + (priceEl ? priceEl.textContent : '');
          }, 2500);
        })
        .catch(function () {
          if (text) text.textContent = 'Error — please try again';
          btn.disabled = false;
        });
    });
  }

  // ── Sticky Bar ────────────────────────────────────────────
  var stickyBar = $('#kp-sticky-bar');
  var buyBox = $('#kp-buybox');
  var stickyAtcBtn = $('#kp-sticky-atc');

  if (stickyBar && buyBox) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          } else {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          }
        });
      },
      { threshold: 0, rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(buyBox);
  }

  // Sticky bar ATC button delegates to main form
  if (stickyAtcBtn && atcForm) {
    stickyAtcBtn.addEventListener('click', function () {
      atcForm.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
    });
  }

  // ── FAQ Tracking (optional analytics hook) ────────────────
  $$('.kp-faq__item').forEach(function (item) {
    item.addEventListener('toggle', function () {
      if (item.open && window.dataLayer) {
        var q = item.querySelector('.kp-faq__question span');
        window.dataLayer.push({
          event: 'faq_open',
          faq_question: q ? q.textContent.trim() : ''
        });
      }
    });
  });

})();
